module.exports = __webpack_public_path__ + "img/abc-news.f6f9cfea.png";